// import React, { useState, useEffect , useRef } from 'react';
// import { useNavigate, Link } from 'react-router-dom';
// import { motion, AnimatePresence } from 'framer-motion';
// import { CheckCircle, Globe } from 'lucide-react';

// import image5 from '../assets/img5.avif';
// import image6 from '../assets/img6.avif';
// import image7 from '../assets/img7.avif';
// import image8 from '../assets/img8.avif';

// import languageLogo from '../assets/Icons/language-icon-matrimony.png';

// const hashFunction = async (text) => {
//   const encoder = new TextEncoder();
//   const data = encoder.encode(text);
//   const hashBuffer = await crypto.subtle.digest('SHA-256', data);
//   const hashArray = Array.from(new Uint8Array(hashBuffer));
//   const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('').substring(0, 8);
//   return `user_${hashHex}`;
// };

// const MobileVerification = () => {
//   const [fullName, setFullName] = useState('');
//   const [mobileNumber, setMobileNumber] = useState('');
//   const [otp, setOtp] = useState('');
//   const [otpSent, setOtpSent] = useState(false);
//   const [verified, setVerified] = useState(false);
//   const [showSuccessTick, setShowSuccessTick] = useState(false);
//   const [language, setLanguage] = useState('english');
//   const [userCount, setUserCount] = useState(10000);
//   const [countdown, setCountdown] = useState(0);
//   const [showLanguageModal, setShowLanguageModal] = useState(false);
//   const [errors, setErrors] = useState({});
//   const [otpMessage, setOtpMessage] = useState('');
//   const [otpError, setOtpError] = useState('');
//   const [languageData, setLanguageData] = useState({});
//   const navigate = useNavigate();
//   const [isLoading, setIsLoading] = useState(true);

//   const translations = {
//     tamil: {
//       mobileVerification: 'மொபைல் சரிபார்ப்பு',
//       enterFullName: 'முழு பெயரை உள்ளிடவும்',
//       enterMobileNumber: 'மொபைல் எண்ணை உள்ளிடவும்',
//       verifyMobile: 'மொபைலை சரிபார்க்கவும்',
//       resendOtp: 'OTP மீண்டும் அனுப்பவும்',
//       enterOtp: 'OTP ஐ உள்ளிடவும்',
//       submitOtp: 'OTP ஐ சமர்ப்பிக்கவும்',
//       otpSent: 'OTP உங்கள் மொபைல் எண்ணுக்கு அனுப்பப்பட்டது!',
//       mobileVerified: 'மொபைல் எண் சரிபார்க்கப்பட்டது! 🎉',
//       invalidMobile: 'சரியான 10-இலக்க மொபைல் எண்ணை உள்ளிடவும்',
//       invalidOtp: 'சரியான 4-இலக்க OTP ஐ உள்ளிடவும்',
//       invalidName: 'முழு பெயரை உள்ளிடவும்',
//       switchLanguage: 'மொழி மாற்று',
//       alreadyHaveAccount: 'ஏற்கனவே கணக்கு உள்ளதா?',
//       login: 'உள்நுழைக',
//       tagline: 'தங்கள் துணையை தேடும் மக்கள்',
//       errorFullName: 'முழு பெயரை உள்ளிடவும்', // Tamil error message
//       errorMobileNumber: 'சரியான 10-இலக்க மொபைல் எண்ணை உள்ளிடவும்', // Tamil error message
//       otp_failed: "OTP அனுப்புவதில் தோல்வி",
//       try_again: "தயவுசெய்து மறுபடியும் முயற்சிக்கவும்.",
//     },
//     english: {
//       mobileVerification: 'Mobile Verification',
//       enterFullName: 'Enter Full Name',
//       enterMobileNumber: 'Enter Mobile Number',
//       verifyMobile: 'Verify Mobile',
//       resendOtp: 'Resend OTP',
//       enterOtp: 'Enter OTP',
//       submitOtp: 'Submit OTP',
//       otpSent: 'OTP sent to your mobile number!',
//       mobileVerified: 'Mobile number verified successfully! 🎉',
//       invalidMobile: 'Please enter a valid 10-digit mobile number',
//       invalidOtp: 'Please enter a valid 4-digit OTP',
//       invalidName: 'Please enter your full name',
//       switchLanguage: 'Switch Language',
//       alreadyHaveAccount: 'Already have an account?',
//       login: 'Login',
//       tagline: 'People searching for their partner',
//       errorFullName: 'Please enter your full name', // English error message
//       errorMobileNumber: 'Please enter a valid 10-digit mobile number', // English error message
//       otp_failed: "Failed to send OTP",
//       try_again: "Please try again.",
//     },
//   };

//   useEffect(() => {
//     if (countdown > 0) {
//       const timer = setTimeout(() => setCountdown(countdown - 1), 1000);
//       return () => clearTimeout(timer);
//     }
//   }, [countdown]);

//   const validateForm = () => {
//     const errors = {};

//     if (!fullName.trim()) {
//       errors.fullName = translations[language].errorFullName;
//     }

//     if (!mobileNumber || !/^\d{10}$/.test(mobileNumber.trim())) {
//       errors.mobileNumber = translations[language].errorMobileNumber;
//     }

//     setErrors(errors);
//     return Object.keys(errors).length === 0;
//   };

//   const handleVerifyMobile = async (e) => {
//     e.preventDefault();
//     if (!validateForm()) return;

//     const formattedMobileNumber = `+91${mobileNumber}`;

//     try {
//       const response = await fetch('https://backend.newbrindha.com/matrimony/send-otp', {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify({
//           mobile_number: formattedMobileNumber,
//           full_name: fullName,
//         }),
//       });

//       if (response.ok) {
//         setOtpSent(true);
//         setCountdown(10);
//         setOtpMessage(translations[language].otpSent);
//         setOtpError('');
//         setUserCount(prevCount => prevCount + 1);
//       } else {
//         const errorData = await response.json();
//         setOtpError(`${translations[language]['otp_failed']}: ${errorData.message || translations[language]['try_again']}`);
//         setOtpMessage('');
//       }
//     } catch (error) {
//       setOtpError('Error sending OTP. Please try again.');
//       setOtpMessage('');
//     }

//     localStorage.setItem("fullName", fullName);
//     localStorage.setItem("mobileNumber", mobileNumber);
//   };

//   const dropdownRef = useRef(null);

// useEffect(() => {
//   const handleClickOutside = (event) => {
//     if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
//       setShowLanguageModal(false);
//     }
//   };
//   document.addEventListener('mousedown', handleClickOutside);
//   return () => {
//     document.removeEventListener('mousedown', handleClickOutside);
//   };
// }, []);

//   const fetchVerifiedUserCount = async () => {
//     try {
//       const response = await fetch('https://analyticsreporting.googleapis.com/v4/reports:batchGet', {
//         method: 'POST',
//         headers: {
//           'Authorization': `Bearer ${process.env.REACT_APP_GA_ACCESS_TOKEN}`, // Use environment variable
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify({
//           reportRequests: [{
//             viewId: process.env.REACT_APP_GA_VIEW_ID, // Use environment variable
//             dateRanges: [{
//               startDate: '2023-01-01',
//               endDate: 'today',
//             }],
//             metrics: [{
//               expression: 'ga:totalEvents',
//             }],
//             dimensions: [{
//               name: 'ga:eventLabel',
//             }],
//             filtersExpression: 'ga:eventLabel==mobile_verification',
//           }],
//         }),
//       });

//       if (!response.ok) {
//         throw new Error(`HTTP error! status: ${response.status}`);
//       }

//       const data = await response.json();

//       // Add proper error handling for missing data
//       if (data?.reports?.[0]?.data?.totals?.[0]?.values?.[0]) {
//         const totalEvents = data.reports[0].data.totals[0].values[0];
//         setUserCount(parseInt(totalEvents, 10) + 10000);
//       } else {
//         console.warn('Analytics data structure not as expected');
//         setUserCount(10000); // Fallback to default
//       }
//     } catch (error) {
//       console.error('Error fetching verified user count:', error);
//       setUserCount(10000); // Fallback to default on error
//     }
//   };

//   useEffect(() => {
//     fetchVerifiedUserCount();
//   }, []);

//   const handleOtpSubmit = async () => {
//     if (!otp || !/^\d{4}$/.test(otp)) {
//       setOtpError(translations[language].invalidOtp);
//       return;
//     }

//     const formattedMobileNumber = `+91${mobileNumber}`;

//     try {
//       const response = await fetch('https://backend.newbrindha.com/matrimony/verify-otp', {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify({
//           mobile_number: formattedMobileNumber,
//           otp,
//           full_name: fullName,
//         }),
//       });

//       if (response.ok) {
//         setVerified(true);
//         setShowSuccessTick(true);
//         setOtpMessage(translations[language].mobileVerified);
//         setOtpError('');

//         try {
//           const hashedName = await hashFunction(fullName);
//           if (window.gtag) {
//             window.gtag('event', 'mobile_verified', {
//               event_category: 'verification',
//               event_label: 'mobile_verification',
//               value: userCount,
//               user_id: hashedName,
//             });
//           }
//         } catch (error) {
//           console.error('Error hashing user data:', error);
//         }

//         setTimeout(() => {
//           navigate('/register');
//         }, 1000);
//       } else {
//         const errorData = await response.json();
//         setOtpError(`Invalid OTP: ${errorData.message || 'Please try again.'}`);
//         setOtpMessage('');
//       }
//     } catch (error) {
//       setOtpError('Error verifying OTP. Please try again.');
//       setOtpMessage('');
//     }
//   };

//   const handleLanguageChange = (selectedLanguage) => {
//     setLanguage(selectedLanguage);
//     localStorage.setItem('selectedLanguage', selectedLanguage);
//     setShowLanguageModal(false);
//   };

//   const toggleLanguageDropdown = () => {
//     setShowLanguageModal(!showLanguageModal);
//   };

//   useEffect(() => {
//     const storedLanguage = localStorage.getItem('selectedLanguage');
//     if (storedLanguage) {
//       setLanguage(storedLanguage);
//     }
//   }, []);

//   useEffect(() => {
//     setLanguageData(translations[language]);
//   }, [language]);

//   return (
//     <div
//       className="min-h-screen flex items-center justify-center p-4 relative overflow-x-hidden overflow-y-hidden"
//       // style={{
//       //   backgroundImage: `url('https://media.istockphoto.com/id/1314780540/photo/indian-traditional-wedding-ceremony-photography.jpg?s=612x612&w=0&k=20&c=ZKDagbzO5WafZxlksbpzYJg46O9aJpINeTjZE3JQXHs=')`,
//       //   backgroundSize: 'cover',
//       //   backgroundPosition: 'center',
//       //   backgroundRepeat: 'no-repeat',
//       // }}
//     >
//       <div></div>
//       <div className="absolute inset-0 grid grid-cols-1 sm:grid-cols-4 gap-0 z-0">
//         {[
//           image5,image6,image7,image8,
//         ].map((img, i) => (
//           <div
//             key={i}
//             className="h-full w-full bg-cover bg-center transform transition-transform duration-500 hover:scale-110"
//             style={{ backgroundImage: `url(${img})` }}
//           />
//         ))}
//       </div>
//        {/* <div className='absolute inset-0 w-full h-screen bg-black opacity-50 overflow-y-hidden overflow-x-hidden'></div> */}

//       <div ref={dropdownRef} className="absolute top-4 right-4 z-20">
//         <button
//           onClick={toggleLanguageDropdown}
//           className="bg-white text-[#d35400] p-2 rounded-full font-medium border border-[#f39c12] hover:bg-[#f39c12] hover:text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#f39c12] transition-all duration-150 ease-in-out transform hover:scale-[1.02] shadow-md shadow-[#f39c12]/20 hover:shadow-[#f39c12]/30"
//         >
//           <img src={languageLogo} alt="language-logo" className="h-8 w-8" />
//         </button>

//         {showLanguageModal && (
//           <motion.div
//             initial={{ opacity: 0, y: -10 }}
//             animate={{ opacity: 1, y: 0 }}
//             exit={{ opacity: 0, y: -10 }}
//             transition={{ duration: 0.2 }}
//             className="absolute right-0 mt-2 w-40 bg-white rounded-lg shadow-lg border border-[#f39c12]/20"
//           >
//             <button
//               onClick={() => handleLanguageChange('english')}
//               className="w-full text-left px-4 py-2 text-[#d35400] hover:bg-[#f39c12] hover:text-white rounded-t-lg"
//             >
//               English
//             </button>
//             <button
//               onClick={() => handleLanguageChange('tamil')}
//               className="w-full text-left px-4 py-2 text-[#d35400] hover:bg-[#f39c12] hover:text-white rounded-b-lg"
//             >
//               தமிழ்
//             </button>
//           </motion.div>
//         )}
//       </div>

//       <motion.div
//         initial={{ opacity: 0, y: -50 }}
//         animate={{ opacity: 1, y: 0 }}
//         transition={{ duration: 0.5 }}
//         className="bg-white/70 backdrop-blur-sm rounded-3xl shadow-2xl p-6 sm:p-8 w-full max-w-md border border-[#f39c12]/20 relative z-10 mx-4"
//       >
//         <motion.div
//           className="text-center text-lg font-bold text-[#d35400] mb-4"
//           initial={{ opacity: 0, y: -50 }}
//           animate={{ opacity: 1, y: 0 }}
//           transition={{ duration: 1, delay: 0.5 }}
//         >
//           {languageData.tagline} <br />
//           <span className="text-3xl">{userCount.toLocaleString()}+</span>
//         </motion.div>

//         <h2 className="text-2xl font-bold text-center text-[#d35400] mb-4">
//           {languageData.mobileVerification}
//         </h2>

//         <form onSubmit={handleVerifyMobile} className="space-y-4">
//             {/* Full Name Input */}
//             <motion.div initial={{ opacity: 0, x: -50 }} animate={{ opacity: 1, x: 0 }} transition={{ duration: 0.5, delay: 0.1 }}>
//               <label className="block text-sm font-medium text-[#d35400]">
//                 {languageData.enterFullName} <span className="text-red-500">*</span>
//               </label>
//               <input
//                 type="text"
//                 value={fullName}
//                 onChange={(e) => setFullName(e.target.value)}
//                 className="w-full px-3 py-2 border rounded-lg shadow-sm focus:ring-blue-500 focus:border-blue-500 text-sm sm:text-base bg-white/70 backdrop-blur-sm"
//                 placeholder={languageData.enterFullName}

//               />
//               {errors.fullName && (
//                 <p className="text-red-500 text-sm mt-1">{errors.fullName}</p>
//               )}
//             </motion.div>

//             {/* Mobile Number Input */}
//             <motion.div
//               initial={{ opacity: 0, x: -50 }}
//               animate={{ opacity: 1, x: 0 }}
//               transition={{ duration: 0.5, delay: 0.2 }}
//             >
//               <label className="block text-sm font-medium text-[#d35400]">
//                 {languageData.enterMobileNumber} <span className="text-red-500">*</span>
//               </label>
//               <input
//                 type="tel"
//                 value={mobileNumber}
//                 onChange={(e) => {
//                   const inputValue = e.target.value;
//                   if (/^\d{0,10}$/.test(inputValue)) {
//                     setMobileNumber(inputValue);
//                   }
//                 }}
//                 className="w-full px-3 py-2 border rounded-lg shadow-sm focus:ring-blue-500 focus:border-blue-500 text-sm sm:text-base bg-white/70 backdrop-blur-sm"
//                 placeholder={languageData.enterMobileNumber}

//               />
//               {errors.mobileNumber && (
//                 <p className="text-red-500 text-sm mt-1">{errors.mobileNumber}</p>
//               )}
//             </motion.div>

//             {/* Verify Mobile Button */}
//             <motion.button
//               type="submit"
//               disabled={countdown > 0}
//               className="w-full bg-gradient-to-r from-[#f39c12] to-[#d35400] text-white px-6 py-2 rounded-full shadow-lg hover:from-[#f39c12]/90 hover:to-[#d35400]/90 transition-all duration-300 text-sm sm:text-base"
//               initial={{ opacity: 0, x: 50 }}
//               animate={{ opacity: 1, x: 0 }}
//               transition={{ duration: 0.5, delay: 0.4 }}
//             >
//               {languageData.verifyMobile}
//             </motion.button>

//             {/* OTP Sent Message */}
//             {otpMessage && (
//               <p className="text-green-500 text-sm mt-2">{otpMessage}</p>
//             )}

//             {/* OTP Error Message */}
//             {otpError && (
//               <p className="text-red-500 text-sm mt-2">{otpError}</p>
//             )}
//           </form>

//         {otpSent && (
//           <motion.div
//             className="space-y-4 mt-4"
//             initial={{ opacity: 0, y: 50 }}
//             animate={{ opacity: 1, y: 0 }}
//             transition={{ duration: 0.5 }}
//           >
//             <input
//               type="text"
//               value={otp}
//               onChange={(e) => setOtp(e.target.value)}
//               className="w-full px-3 py-2 border rounded-lg shadow-sm focus:ring-blue-500 focus:border-blue-500 text-sm sm:text-base bg-white/70 backdrop-blur-sm"
//               placeholder={languageData.enterOtp}
//               required
//             />
//             <button
//               onClick={handleOtpSubmit}
//               className="w-full bg-gradient-to-r from-[#f39c12] to-[#d35400] text-white px-6 py-2 rounded-full shadow-lg hover:from-[#f39c12]/90 hover:to-[#d35400]/90 transition-all duration-300 text-sm sm:text-base"
//             >
//               {languageData.submitOtp}
//             </button>
//           </motion.div>
//         )}

//         {/* Already have an account? Login */}
//         <div className="mt-6 text-center">
//           <p className="text-sm text-[#e67e22]">
//             {languageData.alreadyHaveAccount}{' '}
//             <Link
//               to="/login"
//               className="font-medium text-[#d35400] hover:text-[#f39c12] transition-colors duration-200"
//             >
//               {languageData.login}
//             </Link>
//           </p>
//         </div>
//       </motion.div>

//       {/* Green Tick Animation */}
//       <AnimatePresence>
//         {showSuccessTick && (
//           <motion.div
//             initial={{ opacity: 0, scale: 0 }}
//             animate={{ opacity: 1, scale: 1 }}
//             exit={{ opacity: 0, scale: 0 }}
//             transition={{ duration: 0.5 }}
//             className="fixed inset-0 flex items-center justify-center bg-transparent backdrop-blur-sm z-50"
//           >
//             <CheckCircle className="h-20 w-20 text-green-500" />
//           </motion.div>
//         )}
//       </AnimatePresence>
//     </div>
//   );
// };

// export default MobileVerification;

import React, { useState, useEffect, useRef } from "react";
import { useNavigate, Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { CheckCircle } from "lucide-react";
import { useTranslation } from "react-i18next";
import image5 from "../assets/img5.avif";
import image6 from "../assets/img6.avif";
import image7 from "../assets/img7.avif";
import image8 from "../assets/img8.avif";
import languageLogo from "../assets/Icons/language-icon-matrimony.png";

const hashFunction = async (text) => {
  const encoder = new TextEncoder();
  const data = encoder.encode(text);
  const hashBuffer = await crypto.subtle.digest("SHA-256", data);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  const hashHex = hashArray
    .map((b) => b.toString(16).padStart(2, "0"))
    .join("")
    .substring(0, 8);
  return `user_${hashHex}`;
};

const MobileVerification = () => {
  const { t, i18n } = useTranslation();
  const [fullName, setFullName] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [otp, setOtp] = useState("");
  const [otpSent, setOtpSent] = useState(false);
  const [verified, setVerified] = useState(false);
  const [showSuccessTick, setShowSuccessTick] = useState(false);
  const [userCount, setUserCount] = useState(10000);
  const [countdown, setCountdown] = useState(0);
  const [showLanguageModal, setShowLanguageModal] = useState(false);
  const [errors, setErrors] = useState({});
  const [otpMessage, setOtpMessage] = useState("");
  const [otpError, setOtpError] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [imagesLoaded, setImagesLoaded] = useState(false);
  const navigate = useNavigate();
  const dropdownRef = useRef(null);

  useEffect(() => {
    const loadImages = async () => {
      const imagePromises = [image5, image6, image7, image8].map((src) => {
        return new Promise((resolve, reject) => {
          const img = new Image();
          img.src = src;
          img.onload = resolve;
          img.onerror = reject;
        });
      });

      try {
        await Promise.all(imagePromises);
        setImagesLoaded(true);
        setIsLoading(false);
      } catch (error) {
        console.error("Error loading images:", error);
        setIsLoading(false);
      }
    };

    loadImages();
  }, []);

  useEffect(() => {
    if (countdown > 0) {
      const timer = setTimeout(() => setCountdown(countdown - 1), 1000);
      return () => clearTimeout(timer);
    }
  }, [countdown]);

  // useEffect(() => {
  //   const storedLanguage = localStorage.getItem("language");
  //   if (storedLanguage && ["en", "ta"].includes(storedLanguage)) {
  //     i18n.changeLanguage(storedLanguage);
  //   }
  // }, [i18n]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowLanguageModal(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const validateForm = () => {
    const errors = {};
    if (!fullName.trim()) {
      errors.fullName = t("errorFullName");
    }
    if (!mobileNumber || !/^\d{10}$/.test(mobileNumber.trim())) {
      errors.mobileNumber = t("errorMobileNumber");
    }
    setErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleVerifyMobile = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    const formattedMobileNumber = `+91${mobileNumber}`;

    try {
      const response = await fetch(
        "https://backend.newbrindha.com/matrimony/send-otp",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            mobile_number: formattedMobileNumber,
            full_name: fullName,
          }),
        },
      );

      if (response.ok) {
        setOtpSent(true);
        setCountdown(10);
        setOtpMessage(t("otpSent"));
        setOtpError("");
        setUserCount((prevCount) => prevCount + 1);
      } else {
        const errorData = await response.json();
        setOtpError(`${t("otpFailed")}: ${errorData.message || t("tryAgain")}`);
        setOtpMessage("");
      }
    } catch (error) {
      setOtpError(t("otpError"));
      setOtpMessage("");
    }

    localStorage.setItem("fullName", fullName);
    localStorage.setItem("mobileNumber", mobileNumber);
  };

  const handleOtpSubmit = async () => {
  if (!otp || !/^\d{4}$/.test(otp)) {
    setOtpError(t("invalidOtp"));
    return;
  }

  const formattedMobileNumber = `+91${mobileNumber}`;

  try {
    const response = await fetch(
      "https://backend.newbrindha.com/matrimony/verify-otp",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          mobile_number: formattedMobileNumber,
          otp,
          full_name: fullName,
        }),
      },
    );

    if (response.ok) {
      setVerified(true);
      setShowSuccessTick(true);
      setOtpMessage(t("mobileVerified"));
      setOtpError("");
      
      // Store verification status in localStorage
      localStorage.setItem('mobileVerified', 'true');
      localStorage.setItem('verifiedMobileNumber', mobileNumber);

      try {
        const hashedName = await hashFunction(fullName);
        if (window.gtag) {
          window.gtag("event", "mobile_verified", {
            event_category: "verification",
            event_label: "mobile_verification",
            value: userCount,
            user_id: hashedName,
          });
        }
      } catch (error) {
        console.error("Error hashing user data:", error);
      }

      sessionStorage.setItem('justVerified', 'true');

      // Navigate immediately without timeout
      navigate("/register", { replace: true });
      
    } else {
      const errorData = await response.json();
      setOtpError(
        `${t("invalidOtp")}: ${errorData.message || t("tryAgain")}`,
      );
      setOtpMessage("");
    }
  } catch (error) {
    setOtpError(t("otpError"));
    setOtpMessage("");
    console.error("OTP verification error:", error);
  }
};

  const handleLanguageChange = (selectedLanguage) => {
    i18n.changeLanguage(selectedLanguage);
    localStorage.setItem("language", selectedLanguage);
    setShowLanguageModal(false);
  };

  const toggleLanguageDropdown = () => {
    setShowLanguageModal(!showLanguageModal);
  };

  if (isLoading) {
    return (
      <div className="fixed inset-0 flex items-center justify-center bg-white z-50">
        <motion.div
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.3 }}
          className="text-center"
        >
          <div className="w-16 h-16 border-4 border-[#f39c12] border-t-transparent rounded-full animate-spin"></div>
          <p className="mt-4 text-[#d35400]">{t("loading")}</p>
        </motion.div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center p-4 relative overflow-hidden">
      <div className="absolute inset-0 grid grid-cols-1 sm:grid-cols-4 gap-0 z-0">
        {[image5, image6, image7, image8].map((img, i) => (
          <motion.div
            key={i}
            className="h-full w-full bg-cover bg-center"
            style={{ backgroundImage: `url(${img})` }}
          />
        ))}
      </div>
      <div ref={dropdownRef} className="absolute top-4 right-4 z-20">
        <button
          onClick={toggleLanguageDropdown}
          className="bg-white text-[#d35400] p-2 rounded-full font-medium border border-[#f39c12] hover:bg-[#f39c12] hover:text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#f39c12] transition-all duration-150 ease-in-out transform hover:scale-[1.02] shadow-md shadow-[#f39c12]/20 hover:shadow-[#f39c12]/30"
        >
          <img src={languageLogo} alt="language-logo" className="h-8 w-8" />
        </button>
        {showLanguageModal && (
          <motion.div
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -10 }}
            transition={{ duration: 0.2 }}
            className="absolute right-0 mt-2 w-40 bg-white rounded-lg shadow-lg border border-[#f39c12]/20"
          >
            <button
              onClick={() => handleLanguageChange("en")}
              className="w-full text-left px-4 py-2 text-[#d35400] hover:bg-[#f39c12] hover:text-white rounded-t-lg"
            >
              {t("languages.english")}
            </button>
            <button
              onClick={() => handleLanguageChange("ta")}
              className="w-full text-left px-4 py-2 text-[#d35400] hover:bg-[#f39c12] hover:text-white rounded-b-lg"
            >
              {t("languages.tamil")}
            </button>
          </motion.div>
        )}
      </div>
      <motion.div
        initial={{ opacity: 0, y: -50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="bg-white/70 backdrop-blur-sm rounded-3xl shadow-2xl p-6 sm:p-8 w-full max-w-md border border-[#f39c12]/20 relative z-10 mx-4"
      >
        <motion.div
          className="text-center text-lg font-bold text-[#d35400] mb-4"
          initial={{ opacity: 0, y: -50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.5 }}
        >
          {t("tagline")} <br />
          <span className="text-3xl">{userCount.toLocaleString()}+</span>
        </motion.div>
        <h2 className="text-2xl font-bold text-center text-[#d35400] mb-4">
          {t("mobileVerification")}
        </h2>
        <form onSubmit={handleVerifyMobile} className="space-y-4">
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5, delay: 0.1 }}
          >
            <label className="block text-sm font-medium text-[#d35400]">
              {t("enterFullName")} <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              value={fullName}
              onChange={(e) => setFullName(e.target.value)}
              className="w-full px-3 py-2 border rounded-lg shadow-sm focus:ring-blue-500 focus:border-blue-500 text-sm sm:text-base bg-white/70 backdrop-blur-sm"
              placeholder={t("enterFullName")}
            />
            {errors.fullName && (
              <p className="text-red-500 text-sm mt-1">{errors.fullName}</p>
            )}
          </motion.div>
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5, delay: 0.2 }}
          >
            <label className="block text-sm font-medium text-[#d35400]">
              {t("enterMobileNumber")} <span className="text-red-500">*</span>
            </label>
            <input
              type="tel"
              value={mobileNumber}
              onChange={(e) => {
                const inputValue = e.target.value;
                if (/^\d{0,10}$/.test(inputValue)) {
                  setMobileNumber(inputValue);
                }
              }}
              className="w-full px-3 py-2 border rounded-lg shadow-sm focus:ring-blue-500 focus:border-blue-500 text-sm sm:text-base bg-white/70 backdrop-blur-sm"
              placeholder={t("enterMobileNumber")}
            />
            {errors.mobileNumber && (
              <p className="text-red-500 text-sm mt-1">{errors.mobileNumber}</p>
            )}
          </motion.div>
          <motion.button
            type="submit"
            disabled={countdown > 0}
            className="w-full bg-gradient-to-r from-[#f39c12] to-[#d35400] text-white px-6 py-2 rounded-full shadow-lg hover:from-[#f39c12]/90 hover:to-[#d35400]/90 transition-all duration-300 text-sm sm:text-base"
            initial={{ opacity: 0, x: 50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5, delay: 0.4 }}
          >
            {t("verifyMobile")}
          </motion.button>
          {otpMessage && (
            <p className="text-green-500 text-sm mt-2">{otpMessage}</p>
          )}
          {otpError && <p className="text-red-500 text-sm mt-2">{otpError}</p>}
        </form>
        {otpSent && (
          <motion.div
            className="space-y-4 mt-4"
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
          >
            <input
              type="text"
              value={otp}
              onChange={(e) => setOtp(e.target.value)}
              className="w-full px-3 py-2 border rounded-lg shadow-sm focus:ring-blue-500 focus:border-blue-500 text-sm sm:text-base bg-white/70 backdrop-blur-sm"
              placeholder={t("enterOtp")}
              required
            />
            <button
              onClick={handleOtpSubmit}
              className="w-full bg-gradient-to-r from-[#f39c12] to-[#d35400] text-white px-6 py-2 rounded-full shadow-lg hover:from-[#f39c12]/90 hover:to-[#d35400]/90 transition-all duration-300 text-sm sm:text-base"
            >
              {t("submitOtp")}
            </button>
          </motion.div>
        )}
        <div className="mt-6 text-center">
          <p className="text-sm text-[#e67e22]">
            {t("alreadyHaveAccount")}{" "}
            <Link
              to="/login"
              onClick={(e) => {
                e.preventDefault();
                navigate("/login");
              }}
              className="font-medium text-[#d35400] hover:text-[#f39c12] transition-colors duration-200"
            >
              {t("login")}
            </Link>
          </p>
        </div>
      </motion.div>
      <AnimatePresence>
        {showSuccessTick && (
          <motion.div
            initial={{ opacity: 0, scale: 0 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0 }}
            transition={{ duration: 0.5 }}
            className="fixed inset-0 flex items-center justify-center bg-transparent backdrop-blur-sm z-50"
          >
            <CheckCircle className="h-20 w-20 text-green-500" />
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default MobileVerification;
